import { Injectable } from '@angular/core';
import {PopupMessage} from "./popup-message";

@Injectable()
export class PopupMessageService {
    show: (message: PopupMessage, callback?: Function) => void;
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_commonComp/popup-message/popup-message.service.ts